// ==========================================================================
// PALETTE CENTRALISÉE — rôles structurants uniquement (dark neutre + accent or)
// Source unique de vérité, partagée par App.jsx, JuridictionView, VeilleView.
// Les couleurs sémantiques métier (#10b981 vert, #ef4444 rouge) et les séries
// de graphiques restent locales — non gérées ici à dessein.
// ==========================================================================
export const P = {
  // Fonds (neutres profonds, dé-bleutés)
  bg:           "#0a0a0a",                       // racine
  surface:      "#151515",                       // cartes / panneaux solides
  surfaceDeep:  "#060606",                       // canvas profond
  // Overlays translucides (neutres)
  layer:        "rgba(255,255,255,0.04)",
  layerHover:   "rgba(255,255,255,0.08)",
  border:       "rgba(255,255,255,0.08)",
  borderStrong: "rgba(255,255,255,0.14)",
  // Texte (hiérarchie ≥ AA sur bg/surface)
  text:         "#f2f2f2",                        // principal   (17.7:1)
  textSec:      "#b3b3b3",                        // secondaire  (9.5:1)
  textMuted:    "#8a8a8a",                        // muted       (5.7:1)
  // Accent or (signature, unique)
  accent:       "#C9A84C",                        // texte/bordure or (8.7:1)
  accentSoft:   "rgba(201,168,76,0.12)",          // fond d'état actif discret
  accentBorder: "rgba(201,168,76,0.35)",
  accentText:   "#0a0a0a",                        // texte sur aplat or plein (CTA)
  // Dégradé de fond dé-bleuté (or + neutre, plus de navy/bleu)
  backdrop:     "radial-gradient(ellipse at 15% 0%,rgba(201,168,76,0.06) 0%,transparent 55%),radial-gradient(ellipse at 85% 100%,rgba(201,168,76,0.03) 0%,transparent 55%),radial-gradient(ellipse at 50% 50%,rgba(255,255,255,0.015) 0%,transparent 100%)",
};
